import React from 'react'
import CartePCS from '../../assets/cartePCS.png'
import CarteTranscash from '../../assets/carteTranscash.png'
import CarteRoblo from '../../assets/carteRoblox.svg'

import classNames from 'classnames'
interface Operateur{
    code:string
    name: string
    logo:string
}
interface Props {
  onChange: (value: Operateur) => void
  isOperateur: string
  onChangeStep: any
  functionTracks: any

}


const Operateur: React.FC<Props> = ({ onChange, isOperateur, onChangeStep, functionTracks}) => {
    const listeOperateur: Operateur[] =[
        {code:'0HFR',name:'PCS', logo:CartePCS},
        {code:'0YFR',name:'Transcash', logo:CarteTranscash},
        {code:'4RPT',name:'Roblox', logo:CarteRoblo}

    ]

  return (
    <div className='flex flex-col space-y-[30px] w-full '>
        <h3 className='h3'>Sélectionnez votre type de carte <span className='text-[#EE443F]'>*</span> </h3>
        <div className='flex sm:flex-col items-center justify-center gap-5 '>
            {listeOperateur.map((operateur, index)=>(
                <div key={index} className={`${isOperateur ? (isOperateur===operateur.code ? 'ring-2 ring-[#5754E5] ring-offset-4 rounded-[9px] bg-[#E2E2FB]' : 'opacity-60 bg-[#EEEEEE]'): 'bg-[#EEEEEE] '} flex rounded-[4px]  items-center cursor-pointer  h-[128px] w-[250px] sm:h-[90px] sm:w-[180px] justify-center`}       
                    onClick={() => {  onChange(operateur)}}
                >
                <img className='w-[88px] h-auto'
                    src={operateur.logo}
                    width={139}
                    height={30}
                />
            </div>
            ))}


            {/* <div className={`${isOperateur ? (isOperateur==='0HFR' ? 'ring-2 ring-[#5754E5] ring-offset-4 rounded-[9px] bg-[#E2E2FB]' : 'opacity-60 bg-[#EEEEEE]'): 'bg-[#EEEEEE] '} flex rounded-[4px]  items-center cursor-pointer  h-[128px] w-[250px] sm:h-[90px] sm:w-[180px] justify-center`}       
                onClick={() => { setOperateur('0HFR'), onChange('0HFR')}}
            >
                <img className='w-[88px] h-auto'
                    src={CartePCS}
                    width={139}
                    height={30}
                />
            </div>

            <div className={`${isOperateur ? (isOperateur==='0YFR' ? 'ring-2 ring-[#5754E5] ring-offset-4 rounded-[9px] bg-[#E2E2FB]' : 'opacity-60 bg-[#EEEEEE]'): 'bg-[#EEEEEE] '} flex rounded-[4px] items-center cursor-pointer h-[128px] w-[250px] sm:h-[90px] sm:w-[180px] justify-center`}       
                onClick={() => { setOperateur('0YFR'), onChange('0YFR') }}
            >
                <img className='sm:w-[103px] h-auto'
                    src={CarteTranscash}
                    width={165}
                    height={60}
                />
            </div> */}
        </div>
        <button className= {classNames(`text-[18px] text-[#FFF] h-[56px]  items-center rounded-[16px]  w-full cursor-pointer`, !isOperateur  ? 'bg-[#D1D1FF] ' :'bg-[#5754E5]'  )}
            
         onClick={()=>{functionTracks('1'),onChangeStep(1) } }
         type='submit'
         disabled={!isOperateur}
         >Suivant
         </button>

    </div>
  )
}

export default Operateur
